import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getSpells } from "../logic/Logic.js";

import spellTable from "../data/spellTable.png";

const Play = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    list();
  }, []);

  const list = async () => {
    const ret = { spells: getSpells() };
    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>
      <img src={spellTable} style={{ width: 700, height: 700 }} />
      <br></br>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Spell</th>
            <th>School</th>
            <th>Casting Target</th>
            <th>Category/Range</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {infos?.spells?.map((obj) => {
            return (
              <tr>
                <td>{obj.spell}</td>
                <td>{obj.school}</td>
                <td>{obj.castingvalue}</td>
                <td>{obj.category}</td>
                <td>{obj.desc}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <br></br>
      <br></br>
      <br></br>
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
